// @flow

import React, { useState } from "react";
import moment from "moment";
import { localize } from "redux-i18n";
import { Button, DatePicker, ComboBox, View } from "@components";
import { KPI_MANAGER_REPORT_ORDERS } from "@modules/reporting/constants/reports";
import type { OptionType } from "@components";
import type { ManagerKpiFilters } from "@modules/reporting/reducer/referral-tracker/types";

type OwnProps = $Exact<{
  setFilters: (newFilters: ManagerKpiFilters) => void,
  onExport: () => void,
  onSubmitFilters: () => void,
  filters: ManagerKpiFilters,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

const ManagerKpiReportFilters = (props: Props) => {
  const { t, filters, setFilters } = props;

  const getOrderValues = () => {
    return Object.values(KPI_MANAGER_REPORT_ORDERS).map(value => ({
      label: t(value),
      value: value,
    }));
  };

  const onDateChange = (fieldName: string) => (value: string) => {
    const newFilters = {
      ...filters,
      [fieldName]: value.length ? moment(value).format("YYYY-MM-DD") : "",
    };

    setFilters(newFilters);
  };

  const orderChange = (val: OptionType) => {
    if (typeof val === "string") {
      const newFilters = {
        ...filters,
        sort: val,
      };

      setFilters(newFilters);
    }
  };

  return (
    <View direction="row" justifyContent="space-between" margin={[0, 0, 4, 0]}>
      <View direction="row">
        <View direction="row" alignItems="center" gap={1} margin={[0, 1, 0, 0]}>
          <span className="text-color-charcoal mr-2">{t("FROM")}:</span>
          <DatePicker value={filters.fromDate} onChange={onDateChange("fromDate")} />
        </View>

        <View direction="row" alignItems="center" gap={1} margin={[0, 1, 0, 0]}>
          <span className="text-color-charcoal mr-2">{t("TO")}:</span>
          <DatePicker value={filters.toDate} onChange={onDateChange("toDate")} />
        </View>

        <View direction="row" alignItems="center" gap={1} margin={[0, 1, 0, 0]}>
          <span className="text-color-charcoal mr-2">{t("ORDER_BY")}:</span>
          <View>
            <ComboBox
              withoutEmptyOption={true}
              value={getOrderValues().find(status => status.value === filters.sort)}
              onChange={orderChange}
              options={getOrderValues()}
            />
          </View>
        </View>
        <Button materialIcon="replay_circle_filled" onClick={props.onSubmitFilters}>
          {t("SUBMIT")}
        </Button>
      </View>
      <Button materialIcon="file_download" onClick={props.onExport}>
        {t("EXPORT")}
      </Button>
    </View>
  );
};

export default localize()(ManagerKpiReportFilters);
